const lang = {
  "Hello": "Hello",
  "langs.ko": "Korean",
  "langs.en": "English",
  "entry.button.set_password": "Set Password",
};

export default lang;
